<template>
	<div>		
		<div class="page-filter-box">
			<el-row :gutter="20">
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-input v-model="params.name" placeholder="请输入口令名称" size="small"></el-input>
				</el-col>
				<el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
					<el-date-picker v-model="datetimerange" type="datetimerange" start-placeholder="开始日期"
						end-placeholder="结束日期" class="fl" size="small" value-format="yyyy-MM-dd HH:mm:ss"
						:default-time="['00:00:00', '23:59:59']" align="right" unlink-panels>
					</el-date-picker>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.status" placeholder="请选择" size="small">
						<el-option label="不限制状态" :value="0"></el-option>
						<el-option label="仅看未开始的" :value="1"></el-option>
						<el-option label="仅看进行中的" :value="2"></el-option>
						<el-option label="仅看已结束的" :value="3"></el-option>
					</el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
					<el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
					<el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="page-btns-box">
			<el-button v-if="$utils.have('/promotion/commend/edit')" type="primary" icon="el-icon-plus" size="small"
				@click="$refs.codeEdit.show()">新建口令</el-button>
		</div>
		<div class="page-list-box">
			<el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
				<el-table-column prop="status" label="状态">
					<template slot-scope="scope">
						<span v-if="scope.row.status==1">未开始</span>
						<span v-else-if="scope.row.status==2" class="color-success">进行中</span>
						<span v-else-if="scope.row.status==3" class="color-danger">已结束</span>
					</template>
				</el-table-column>
				<el-table-column prop="name" label="口令名称" min-width="200" show-overflow-tooltip></el-table-column>
				<el-table-column prop="commendCode" label="口令Code"></el-table-column>
				<el-table-column prop="remark" label="备注"></el-table-column>
				<el-table-column prop="couponRuleId" label="关联优惠券"></el-table-column>
				<el-table-column prop="pushTime" label="口令有效期" min-width="130">
					<template slot-scope="scope">
						<p>起：{{ scope.row.startTime }}</p>
						<p>止：{{ scope.row.endTime }}</p>
					</template>
				</el-table-column>
				<el-table-column prop="searchNum" label="搜索人数"></el-table-column>
				<el-table-column prop="newUserNum" label="拉新人数"></el-table-column>
				<el-table-column prop="pagePv" label="优惠领取页面PV" min-width="120"></el-table-column>
				<el-table-column prop="pageUv" label="优惠券领取页面UV" min-width="120"></el-table-column>
				<el-table-column prop="receiveUserNum" label="领券人数"></el-table-column>
				<el-table-column prop="usedUserNum" label="用券人数"></el-table-column>
				<el-table-column prop="orderNum" label="订单数"></el-table-column>
				<el-table-column prop="orderAmount" label="订单金额"></el-table-column>
				<el-table-column fixed="right" label="操作" width="120">
					<template slot-scope="scope">
						<el-button v-if="$utils.have('/promotion/commend/edit') && scope.row.status!= 0" type="text"
							size="small" icon="el-icon-s-management" @click="edit(scope.row)">详情
						</el-button>
						<el-button v-if="$utils.have('/promotion/commend/delete')" type="text" size="small"
							icon="el-icon-delete" @click="del(scope.row)">删除</el-button>						
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div v-if="data" class="page-pagination-box">
			<el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
				:current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
				layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
			</el-pagination>
		</div>
		<edit ref="codeEdit" @onUpdate="getDataList()"></edit>
	</div>
</template>

<script>
	const defaultParams = {
		pageNo: 1,
		status: 0,
		startTime: '',
		endTime: '',
		name: ''
	}
	import Edit from './edit/index.vue';
	export default {
		components: {
			Edit
		},
		data() {
			return {
				data: null,
				dataList: null,
				params: {
					...defaultParams,
					pageNo: parseInt(this.$route.query.pageNo || 1),
					pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
					status: this.$route.query.status || 0,
					startTime: this.$route.query.startTime || '',
					endTime: this.$route.query.endTime || '',
					name: this.$route.query.name || '',
				},
				listLoading: true,
				datetimerange: [this.$route.query.startTime || '', this.$route.query.endTime || ''],


			}
		},
		computed: {

		},
		mounted() {
			this.getDataList();
		},
		methods: {
			//获取列表
			getDataList() {
				this.params = {
					...this.params,
					startTime: this.datetimerange && this.datetimerange[0] || '',
					endTime: this.datetimerange && this.datetimerange[1] || ''
				}
				this.listLoading = true;
				this.$request({
						url: "/promotion/commend/list",
						method: "POST",
						data: {
							...this.params,
						},
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1 && result) {
							this.data = result;
							this.dataList = result.result || [];

						} else {
							this.data = null;
							this.dataList = [];
							this.$message.error(msg || "请求失败");
						}
					})
					.catch(() => {
						this.$message.error("请求错误");
					})
					.finally(() => {
						this.listLoading = false;
					});
			},
			//选择pageSize
			handleSizeChange(e) {
				this.params.pageNo = 1;
				this.params.pageSize = e;
				this.getDataList();
			},
			//搜索
			search() {
				this.params.pageNo = 1;
				this.getDataList();
			},
			//重置搜索
			reset() {
				this.datetimerange = [];
				this.params = {
					...defaultParams,
					pageSize: this.params.pageSize,
				};
				this.getDataList();
			},
			//删除
			del(data) {
				this.$confirm('确认删除口令' + data.name + '?', '删除', {
					center: true,
				}).then(() => {
					this.$request({
							url: "/promotion/commend/delete",
							method: "POST",
							params: {
								id: data.id
							},
						})
						.then((res) => {
							const {
								state,
								msg
							} = res.data;
							if (state == 1) {
								this.getDataList();
							} else {
								this.$message.error(msg || "请求失败");
							}
						})
						.catch(() => {
							this.$message.error("请求错误");
						})
				}).catch(() => {

				})
			},
			//编辑
			edit(data) {
				this.$refs.codeEdit.show(data);
			}

		}
	}
</script>